import React from "react";
import { Image as ImageItem } from "antd";

interface ImageProps {
  src: string;
  width?: string;
  height?: string;
  size?: string;
  alt?: string;
  fit?: "cover" | "contain" | "fill" | "none";
  onClick?: () => void;
  radius?: number | string;
  minWidth?: string;
  pointer?: boolean;
}

const Image = ({
  src,
  width,
  height,
  alt,
  fit = "cover",
  size,
  onClick,
  radius = 0,
  minWidth,
  pointer = false,
}: ImageProps) => {
  return (
    <>
      <ImageItem
        src={src}
        width={size ? size : width ? width : "24px"}
        height={size ? size : height ? height : "24px"}
        alt={alt ? alt : ""}
        preview={false}
        onClick={onClick ? onClick : undefined}
        style={{
          objectFit: fit,
          display: "flex",
          verticalAlign: "middle",
          zIndex: 1,
          borderRadius: radius,
          minWidth: minWidth ? minWidth : "",
          cursor: onClick || pointer ? "pointer" : "default",
        }}
      />
    </>
  );
};

export default Image;
